import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function DMCA() {
  return (
    <div className="page-container">
      <Helmet>
        <title>DMCA Policy | Alpha APK Store</title>
        <meta name="description" content="Alpha APK Store DMCA takedown policy and copyright infringement reporting." />
        <link rel="canonical" href="https://www.alphaapkstore.com/dmca" />
      </Helmet>
      
      <h1>DMCA / Copyright Policy</h1>
      
      <p>Alpha APK Store respects the intellectual property rights of others and expects users to do the same.</p>
      
      <h2>Reporting Copyright Infringement</h2>
      <p>If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement, please provide our Copyright Agent with the following information:</p>
      
      <ol>
        <li>A physical or electronic signature of the copyright owner or authorized agent</li>
        <li>Identification of the copyrighted work claimed to have been infringed</li>
        <li>Identification of the material that is claimed to be infringing and its location on our site</li>
        <li>Your contact information (address, phone, email)</li>
        <li>A statement that you have a good faith belief that the use is not authorized</li>
        <li>A statement that the information is accurate and you are authorized to act on behalf of the copyright owner</li>
      </ol>
      
      <h2>Contact Information</h2>
      <p>Email: <a href="mailto:alphaapkstore@gmail.com">alphaapkstore@gmail.com</a></p>
      <p>Please include "DMCA Takedown Request" in the subject line.</p>
      
      <h2>Counter-Notification</h2>
      <p>If you believe your material was removed by mistake, you may submit a counter-notification containing your contact information, consent to jurisdiction, and a statement under penalty of perjury.</p>
      
      <Link to="/">← Back to Home</Link>
    </div>
  );
}